// Vendor imports
const Immutable = require('immutable')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Client V2 common imports
const { PageContextOverrideRecord } = require('client-v2/common/models/page-context/records')
const { keyedReviver } = require('client-v2/common/state/revivers')

class FeedStreamMetaRecord extends Immutable.Record({
  nextUrl: null,
  recBatchId: null,
  streamId: null,
  streamKey: null,
  streamType: null,
  title: null,
  total: null,
  // Interleaved feed keys
  mixRecBatchId: null,
  urlRecBatchId: null
}) {
  getRecBatchId(modelType) {
    let recBatchId
    // Handle interleaved rec batches
    switch (modelType) {
      case modelTypes.ARTICLE:
        recBatchId = this.urlRecBatchId
        break
      case modelTypes.MIX:
        recBatchId = this.mixRecBatchId
        break
    }
    // Fall-back to non-interleaved
    return recBatchId || this.recBatchId
  }

  getPageContext(modelType) {
    return new PageContextOverrideRecord({
      recBatchId: this.getRecBatchId(modelType),
      streamId: this.streamId,
      streamKey: this.streamKey,
      streamType: this.streamType
    })
  }

  getPageContextForFeedItem(feedItem) {
    const { recId } = feedItem.meta
    return this.getPageContext(feedItem.type).merge({ recId })
  }

  matchesPageContext(pageContext) {
    return (
      this.streamType === pageContext.streamType &&
      (
        this.streamId === pageContext.streamId ||
        this.streamKey === pageContext.streamKey
      )
    )
  }
}

FeedStreamMetaRecord.reviver = keyedReviver(FeedStreamMetaRecord, {
  // No nested data structures
})

module.exports = FeedStreamMetaRecord
